import clsx from 'clsx'
import { HTMLMotionProps, motion } from 'motion/react'
import { ReactNode, RefObject } from 'react'
import styles from './Page.module.css'

export interface PageProps extends Omit<HTMLMotionProps<'div'>, 'title' | 'children'> {
	children?: ReactNode

	header?: ReactNode

	ref?: RefObject<HTMLDivElement>
}

export default (function Page({ children, header, ref, className, ...props }: PageProps) {
	return (
		<motion.div
			initial={{
				opacity: 0,
			}}
			animate={{
				opacity: 1,
				transition: {
					duration: 0.1,
				},
			}}
			ref={ref}
			className={clsx(styles.root, className)}
			{...props}
		>
			{header}
			{children}
		</motion.div>
	)
})
